var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyInr = function SvgIconCurrencyInr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.125 4.75H6.75a1 1 0 0 1 0-2h12a1 1 0 1 1 0 2h-4.21c.457.52.815 1.113 1.062 1.75h3.148a1 1 0 1 1 0 2h-2.751l.001.125a5.875 5.875 0 0 1-5.875 5.875h-.788l6.336 5.76a1 1 0 1 1-1.346 1.48l-8.25-7.5a1 1 0 0 1 .673-1.74h3.375a3.875 3.875 0 0 0 3.873-4H6.75a1 1 0 0 1 0-2h6.615a3.87 3.87 0 0 0-3.24-1.75"
  })));
};
export default SvgIconCurrencyInr;